export default "__VITE_ASSET__CfYGtqWa__"